import React from 'react'
import clsx from 'clsx'

import isDefaultProductCardStyle from '../utils/isDefaultProductCardStyle'

import styles from './ProductImageLoadingSpinner.module.scss'

export default function ProductImageLoadingSpinner() {
  const defaultProductCardStyle = isDefaultProductCardStyle()

  return (
    <div
      className={clsx(styles.spinner, {
        [styles.imageOnTopStyle]: !defaultProductCardStyle,
      })}
    />
  )
}
